<template>
    <div
        ref="rootElementRef"
        data-component="AmsTooltipPopover"
        class="relative"
        :class="{ 'z-content-badge': isActive }"
    >
        <cs-tooltip
            ref="tooltipRef"
            :position="localPosition"
            :showOnHover="showOnHover"
            @tooltip-open="onTooltipOpen"
            @tooltip-close="onTooltipClose"
        >
            <ms-headline class="mb-8" type="h4"> {{ tooltip.title }} </ms-headline>

            <span>
                {{ tooltip.text }}
            </span>

            <div v-if="tooltip?.url" class="mt-15 inline-block">
                <cs-secondary-button
                    class="self-start"
                    :href="tooltip.url"
                    target="_blank"
                    rel="noopener nofollow"
                    isSmall
                >
                    {{ tooltip.prefix }}
                    {{ tooltip.linkText }}
                </cs-secondary-button>
            </div>
            <template #trigger>
                <div class="z-content relative">
                    <slot :isActive="isActive" />
                </div>
            </template>
        </cs-tooltip>
    </div>
</template>

<script lang="ts" setup>
import { CsSecondaryButton, CsTooltip, MsHeadline } from '@sunrise/components'
import { Components } from '@sunrise/types'
import { Tooltip } from './AmsTooltip.interface'
import { ref, toRef } from 'vue'
import { useDynamicTooltipPosition } from './useDynamicTooltipPosition'

interface Props {
    tooltip: Tooltip
    position?: Components.CsTooltip.TooltipPosition
    showOnHover?: boolean
}

const isActive = ref(false)

const rootElementRef = ref<HTMLDivElement>()

const onTooltipOpen = () => {
    isActive.value = true
}

const onTooltipClose = () => {
    isActive.value = false
}

const props = withDefaults(defineProps<Props>(), {
    showOnHover: true,
})

const localPosition = props.position ? toRef(props.position) : useDynamicTooltipPosition(rootElementRef)
</script>
